module.exports = __webpack_public_path__ + "img/code1.8a3d27a7.jpg";